import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { BussinesAreaModal } from "./components/BussinesAreaModal";
import { useBussinesAreaStore } from "../../hooks/useBussinesAreaStore";
import { useImportStore } from "../../hooks/useImportStore";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'branchoffice', label: 'Sucursal', align: 'center' },
    { type: 'text', field: 'status', label: 'Estado', align: 'center', format: (row) => row.status == 1 ? 'Activado' : 'Desactivado' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Áreas de negocio', pathname: RoutesMap.BUSSINES_AREA }
]

export const BussinesAreaView = () => {

    const { setActionBussinesArea, getBussinesArea, getBussinesAreaByCompany, deleteBussinesArea, changeStatusBusinessArea } = useBussinesAreaStore();
    const { status: statusImport, downloadTemplate } = useImportStore()

    const [loading, setLoading] = useState(false);
    const [businessAreas, setBusinessAreas] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getBussinesAreaApi()
    }, [])

    const getBussinesAreaApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getBussinesArea(search);
            if (!response) {
                setBusinessAreas([]);
                setLoading(false);
                return false;
            } else {
                setBusinessAreas(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionBussinesArea('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected: any) => {
        setActionBussinesArea('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionBussinesArea('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionBussinesArea('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteBussinesArea(rowSelected.id)
            if (response) {
                getBussinesAreaApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const onSwitch = async (rowSelected) => {
        const statusrow = rowSelected?.status == '0' ? '1' : '0';
        setLoading(true);
        const response: any = await changeStatusBusinessArea(rowSelected.id, { status: statusrow });
        if (response) {
            getBussinesAreaApi();
            setLoading(false);
            setRowSelected('');
        } else {
            setLoading(false);
            return false;
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getBussinesAreaApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    const downloadTemplateApi = async () => {
        const url: string | false = await downloadTemplate(2) //2: areas de negocio
        if (url === false) return

        const win: any = window.open(`${process.env.REACT_APP_ROOT_URL}` + url)
        win.focus()
    }

    const onImport = async (event) => {
        const file = event.target.files[0]
        if (file) {

        }
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Areas de negocio'}
                    columns={columns}
                    loading={loading}
                    rows={businessAreas || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva area de negocio'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    onSwitch={onSwitch}
                    dense
                    onImport={onImport}
                    template={downloadTemplateApi}
                />
            </Grid>
            {
                showModal && (
                    <BussinesAreaModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        areaSelected={rowSelected}
                        listArea={getBussinesAreaApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}